/** UK postcode regex (case-insensitive, with or without space) */
const UK_POSTCODE_REGEX = /^[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}$/i;

/** Check if a string matches the format of a valid UK postcode */
export function isValidPostcodeFormat(postcode: string): boolean {
  return UK_POSTCODE_REGEX.test(postcode.trim());
}

/**
 * Format a postcode to standard form: uppercase with space before last 3 chars.
 * e.g. "sw1a1aa" -> "SW1A 1AA"
 */
export function formatPostcode(postcode: string): string {
  const cleaned = postcode.replace(/\s+/g, "").toUpperCase();
  if (cleaned.length < 5 || cleaned.length > 7) return cleaned;
  return `${cleaned.slice(0, -3)} ${cleaned.slice(-3)}`;
}
